import { render, staticRenderFns } from "./submitSuccess.vue?vue&type=template&id=b915334c&scoped=true&"
import script from "./submitSuccess.vue?vue&type=script&lang=js&"
export * from "./submitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./submitSuccess.vue?vue&type=style&index=0&id=b915334c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b915334c",
  null
  
)

export default component.exports